export default [
    {
        label: 'Experience with special needs',
        value: 1,
    },
    {
        label: 'Extensive knowledge and history working with newborns',
        value: 2,
    },
    {
        label: 'Education/experience in early childhood development',
        value: 3,
    },
    {
        label: 'Education/experience in healthcare (nursing, OT, PT)',
        value: 4,
    },
    {
        label: 'Educated/willing to be educated in the use of an epipen',
        value: 5,
    },
    {
        label: 'Experience with tutoring/virtual learning assistance',
        value: 6,
    },
    {
        label: 'Add my own',
        value: 1000,
    },
];
